var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Titulo',{attrs:{"titulo":"HISTORIAL DE CONSUMOS DE AGUA"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }